import React, { useLayoutEffect, useRef, useState } from "react";

import { Card, CardContent, CardMedia, makeStyles } from "@material-ui/core";
import clsx from "clsx";

import { AA_BRAND_NAME } from "@ds-developer/constants";
import { Brand } from "@ds-developer/models";

import AALogo from "../../images/aadLogo";
import BSMBackgroundImage from "../../images/bsmBackground";
import BSMLogo from "../../images/bsmLogo";

import { FormCardProps } from "./types";

const useStyles = (brand: Brand) =>
  makeStyles(theme => ({
    card: {
      width: theme.breakpoints.values.md,
      maxWidth: "100%",
      overflow: "visible",
      display: "flex",
      position: "relative",
      "& > *": {
        flexGrow: 1,
        flexBasis: "50%",
        width: "50%",
      },
    },
    content: {
      padding: theme.spacing(8, 4, 3, 4),
    },
    aaBackgroundImage: {
      width: "100%",
      height: "100%",
      backgroundImage: "url(/images/aabackground.jpg)",
      backgroundSize: "cover",
      backgroundPosition: "bottom center",
    },
    media: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },

      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
      padding: 0,
      display: "flex",
      overflow: "hidden",
      flexDirection: "column",
      justifyContent: "flex-end",
      backgroundColor: "#F8F7F9",

      "&.BSM": {
        justifyContent: "center",
        alignItems: "center",
      },
    },
    icon: {
      borderRadius: theme.shape.borderRadius,
      background: theme.palette.brand[brand],
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(1),
      position: "absolute",
      top: -32,
      left: theme.spacing(3),
      height: 64,
      width: 64,
      fontSize: 32,
    },
  }));

const FormCard: React.FC<FormCardProps> = ({
  brand,
  children,
}): JSX.Element => {
  const classes = useStyles(brand)();
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const ref = useRef<Element>(null);

  useLayoutEffect(() => {
    setHeight(ref?.current?.clientHeight || 0);
    setWidth(ref?.current?.clientWidth || 0);
  });

  return (
    <Card className={classes.card} ref={ref}>
      <CardContent className={classes.content}>
        <div className={classes.icon}>
          {brand === AA_BRAND_NAME ? <AALogo /> : <BSMLogo />}
        </div>
        {children}
      </CardContent>
      <CardMedia className={clsx(classes.media, brand)} title="Cover">
        {brand === AA_BRAND_NAME ? (
          <div className={classes.aaBackgroundImage}></div>
        ) : (
          <BSMBackgroundImage height={height} width={width} />
        )}
      </CardMedia>
    </Card>
  );
};

export default FormCard;
